const steps = [
  { num: 1, label: 'Configure', desc: 'Pick strategy, asset, timeframe, and capital' },
  { num: 2, label: 'Backtest', desc: 'Run simulation and review equity curve + metrics' },
  { num: 3, label: 'Validate', desc: 'Walk-forward analysis on unseen data' },
];

export default function WorkflowStepsMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> The Workflow</div>
      <div className="platform-mock-body">
        <div className="mock-steps">
          {steps.map((s, i) => (
            <span key={s.num} style={{ display: 'contents' }}>
              {i > 0 && <div className="mock-step-arrow">&rarr;</div>}
              <div className="mock-step">
                <div className="mock-step-num">{s.num}</div>
                <div className="mock-step-label">{s.label}</div>
                <div className="mock-step-desc">{s.desc}</div>
              </div>
            </span>
          ))}
        </div>
      </div>
      <div className="platform-mock-caption">Configure, test, validate &mdash; the three steps to strategy confidence.</div>
    </div>
  );
}
